export default {
  methods: {
    trackEvent(event, category, action, label = null, value = null, args = {}) {
      if (this.$gtm.enabled()) {
        this.$gtm.trackEvent({
          event, category, action, label, value, noninteraction: true, ...args,
        });
      }
    },
  },
};
